/* eslint-disable import/no-cycle */
import { IRoute, RouterItemPg } from 'viggo-sistemas-core-web';
import {
  filterGrantMenuItens,
  ordemAlfabetica,
  ordemPrecendecia
} from '../menu.service';

export class MenuSysadmin {
  constructor() {}

  /**
   * Cria o menu lateral de Localização
   * @param routes Rotas pemitidas ao usuário
   */
  createLocalizacaoMenu(routes: IRoute[]) {
    let menu: RouterItemPg;
    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Mesoregiões',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/mesorregioes'],
          idElement: 'menu-mesoregiao'
        },
        matchBackendRoutes: [{ url: '/mesorregioes/<id>', method: 'PUT' }]
      },
      {
        menuItem: {
          label: 'Microregiões',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/microrregioes'],
          idElement: 'menu-microregiao'
        },
        matchBackendRoutes: [
          {
            url: '/microrregioes/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'Municípios',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/municipios'],
          idElement: 'menu-municipio'
        },
        matchBackendRoutes: [
          {
            url: '/municipios/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'Regiões',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/regioes'],
          idElement: 'menu-regiao'
        },
        matchBackendRoutes: [
          {
            url: '/regioes/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'Países',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/paises'],
          idElement: 'menu-pais'
        },
        matchBackendRoutes: [
          {
            url: '/paises/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'UFs',
          icon: 'pi pi-fw pi-map',
          routerLink: ['/ufs'],
          idElement: 'menu-uf'
        },
        matchBackendRoutes: [{ url: '/ufs/<id>', method: 'PUT' }]
      }
    ]);

    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Localização',
        icon: 'pi pi-fw pi-map',
        routerLink: null,
        idElement: 'menu-localizacao',
        items: submenu
      };
    return menu;
  }

  /**
   * Cria o menu lateral de Precificação
   * @param routes Rotas pemitidas ao usuário
   */
  createPrecificacaoMenu(routes: IRoute[]) {
    let menu: RouterItemPg;
    let submenu = [] as RouterItemPg[];
    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Serviços',
          icon: 'pi pi-fw pi-wrench',
          routerLink: ['/servicos_precificacao'],
          idElement: 'menu-servicos-precificacao',
          precedence: 1
        },
        matchBackendRoutes: [{ url: '/servico_viggos/<id>', method: 'PUT' }]
      },
      {
        menuItem: {
          label: 'Produtos',
          icon: 'pi pi-fw pi-box',
          routerLink: ['/produtos_precificacao'],
          idElement: 'menu-produtos-precificacao',
          precedence: 2
        },
        matchBackendRoutes: [{ url: '/produto_viggos/<id>', method: 'PUT' }]
      },
      {
        menuItem: {
          label: 'Termos',
          icon: 'pi pi-fw pi-file-check',
          routerLink: ['/termos_precificacao'],
          idElement: 'menu-termos-precificacao',
          precedence: 3
        },
        matchBackendRoutes: [
          { url: '/termo_aceite_viggos/<id>', method: 'PUT' }
        ]
      },
      {
        menuItem: {
          label: 'Planos',
          icon: 'mdi mdi-file-plus-outline',
          routerLink: ['/planos_precificacao'],
          idElement: 'menu-planos-precificacao',
          precedence: 4
        },
        matchBackendRoutes: [{ url: '/plano_viggos/<id>', method: 'PUT' }]
      },
      {
        menuItem: {
          label: 'Contratos',
          icon: 'mdi mdi-handshake-outline',
          routerLink: ['/contratos_precificacao'],
          idElement: 'menu-contratos-precificacao',
          precedence: 5
        },
        matchBackendRoutes: [{ url: '/contrato_viggos/<id>', method: 'PUT' }]
      },
      {
        menuItem: {
          label: 'Relatório financeiro geral',
          routerLink: ['/relatorio/financeiro_geral'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-relatorio-financeiro'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/domains/relatorio_financeiro_geral'
          }
        ]
      }
    ]);

    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        label: 'Precificação',
        icon: 'mdi mdi-currency-brl',
        routerLink: null,
        idElement: 'menu-precificacao',
        items: submenu
      };
    return menu;
  }
}
